// Global method for getting a label from the statemanager.
// It relies on a Vuex Action and is, mostly, a wrapped action for easier use in components.
// A label must be available for readout, or the method returns the labelKey itself - indicating there is a missing label.

import { useStore } from 'vuex'

/**
 *
 * @param {Object} config
 * @param {String} config.labelKey - key of the label
 * @param {String} config.labelCollection - name of the label collection
 * @param {String} config.params - parameters to interpolate
 * @returns
 */
export default function (config) {
    const store = useStore()
    const returnedLabel = store.getters['labels/getLabel'](config)
    if (returnedLabel !== undefined && config.allowEmpty) return returnedLabel

    return returnedLabel || config.labelKey
}